import routerOptions0 from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/runner/_work/eco.store.ecommerce-web/eco.store.ecommerce-web/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}